import { FormControl, MenuItem, Select, TextField } from "@mui/material";
import React from "react";

export default function Input({ input, inputPadding, onChange }) {
  return (
    <>
      {input.options?.[0] ? (
        <FormControl fullWidth>
          <Select
            labelId="input-label"
            id="input"
            value={input.value}
            onChange={onChange}
            sx={{ "& div": { p: inputPadding } }}
          >
            {input.options.map((opt) => {
              return (
                <MenuItem value={opt} key={opt}>
                  {opt}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
      ) : (
        <TextField
          variant="outlined"
          value={input.value}
          name={input.name}
          fullWidth
          sx={{ "& input": { p: inputPadding } }}
        />
      )}
    </>
  );
}
